module.exports = __webpack_public_path__ + "static/img/subscribe_schedule.7f4a680.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/subscribe_schedule.png
// module id = UWGI
// module chunks = 4